import {ISharedWithUser, IUser} from '../../../../../../models';
import {fullName} from '../../../../../../utils/user';
import {UserSuggestItem} from './types';

export const getUserPermission = (sharedWithUser: any): string => {
  if (!sharedWithUser) {
    return '';
  }
  return sharedWithUser.edit ? 'edit' : sharedWithUser.view ? 'view' : '';
}

export const suggestUserOptions = (
  recipients: Partial<IUser>[],
  selected: ISharedWithUser[],
  createdBy?: Partial<IUser>,
): UserSuggestItem[] => {
  const selectedUid = selected.map((s: any) => s.uid);

  return recipients.map((user: Partial<IUser>): UserSuggestItem => {
    return {
      value: fullName(user) || user.email as string,
      uid: user.uid as string
    }
  }).filter((value: UserSuggestItem) => {
    if (value.uid === createdBy?.uid) {
      return false; // don't suggest the user that created the report as it's the "owner"
    }
    return !selectedUid.includes(value.uid);
  });
}
